module.exports = __webpack_public_path__ + "img/ic_edit.8a73d956.svg";